import { LocalizedString, localizedStringFromMap } from './LocalizedString';

export interface ResearchStudy {
  title: string;
  authors: string;
  journal: string;
  year: number;
  keyFinding: LocalizedString;
  url: string;
}

export function researchStudyFromJson(json: Record<string, unknown>): ResearchStudy {
  return {
    title: json['title'] as string,
    authors: json['authors'] as string,
    journal: json['journal'] as string,
    year: json['year'] as number,
    keyFinding: localizedStringFromMap(json['keyFinding'] as Record<string, unknown>),
    url: json['url'] as string,
  };
}
